<main class="container" id="main">
    <div class="container__inner">
        <div class="container__header">
            <h1>Scope <span class="color-primary">2.0</span> Web Styleguide<span class="color-primary">.</span></h1>
            <div class="container__subline"
                >Everything you need to know about the riege components. Proudly presented by the
                <span class="color-primary">UI/UX/Frontend Team</span>.</div
            >
        </div>

        <button
            mat-icon-button
            class="riege-button riege-button--icon styleguide__sidenav"
            color="accent"
            (click)="toggleStyleguideNavigation()"
            aria-label="styleguide side navigation button">
            <mat-icon class="riege-icon">menu</mat-icon>
        </button>

        <ng-template #sidenavTemplate>
            <mat-dialog-content>
                <!-- Static Navigation Bar -->
                <nav class="styleguide-nav">
                    <h2>Fast navigation (click on a component)</h2>
                    <ul class="styleguide-nav__list">
                        <li><a (click)="navigateTo('typography')">Typography</a></li>
                        <li><a (click)="navigateTo('color-palette')">Color Palette</a></li>
                        <li><a (click)="navigateTo('avatar-select')">Avatar Select</a></li>
                        <li><a (click)="navigateTo('badge')">Badge</a></li>
                        <li><a (click)="navigateTo('button')">Button</a></li>
                        <li><a (click)="navigateTo('button-toggle')">Button Toggle</a></li>
                        <li><a (click)="navigateTo('card')">Card</a></li>
                        <li><a (click)="navigateTo('card-marketing')">Card Marketing</a></li>
                        <li><a (click)="navigateTo('card-community')">Card Community</a></li>
                        <li><a (click)="navigateTo('card-image')">Card Image</a></li>
                        <li><a (click)="navigateTo('chips')">Chips</a></li>
                        <li><a (click)="navigateTo('dialog')">Dialog</a></li>
                        <li><a (click)="navigateTo('dropzone')">Dropzone</a></li>
                        <li><a (click)="navigateTo('form-fields')">Form Fields</a></li>
                        <li><a (click)="navigateTo('icons')">Icons</a></li>
                        <li><a (click)="navigateTo('menu')">Menu</a></li>
                        <li><a (click)="navigateTo('paginator')">Paginator</a></li>
                        <li><a (click)="navigateTo('progress-bar')">Progress Bar</a></li>
                        <li><a (click)="navigateTo('slider')">Slider</a></li>
                        <li><a (click)="navigateTo('slide-toggle')">Slide Toggle</a></li>
                        <li><a (click)="navigateTo('snackbar')">Snackbar</a></li>
                        <li><a (click)="navigateTo('table')">Table</a></li>
                        <li><a (click)="navigateTo('tabs')">Tabs</a></li>
                        <li><a (click)="navigateTo('textlink')">Textlink</a></li>
                        <li><a (click)="navigateTo('tooltip')">Tooltip</a></li>
                    </ul>
                </nav>
            </mat-dialog-content>
            <button
                mat-icon-button
                class="riege-button riege-button--icon sidepanel__close md-16"
                color="accent"
                aria-label="Close"
                i18n-aria-label="@@button-label-close"
                matDialogClose>
                <mat-icon>close</mat-icon>
            </button>
        </ng-template>

        <div class="container__main-content">
            <!-- Typography -->
            <div class="container__component" id="typography">
                <h2 class="container__title">Riege Typography</h2>
                <div class="container__row flex--direction-column">
                    <h1>Heading h1</h1>
                    <h2>Heading h2</h2>
                    <h3>Heading h3</h3>
                    <h4>Heading h4</h4>

                    <p
                        >Paragraph - Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt rem tempore
                        blanditiis pariatur perferendis soluta, non consequuntur dolorum. Sunt qui amet, odit similique
                        dignissimos soluta rem quas a at pariatur!</p
                    >
                </div>
            </div>

            <!-- Color Palette -->
            <div class="container__component" id="color-palette">
                <h2 class="container__title">Riege Color Palette</h2>
                <div class="container__subtitle">
                    These are the primarly used colors. There are way more specific colors in the
                    riege-color-palette.scss if needed.
                </div>
                <div class="container__row flex--direction-column">
                    <div class="container__row-item"
                        ><span class="color-box color-primary"></span> Primary (--color-primary: #e8b909)</div
                    >
                    <div class="container__row-item"
                        ><span class="color-box color-secondary"></span> Secondary (--color-secondary: #000000)</div
                    >
                    <div class="container__row-item"
                        ><span class="color-box color-error"></span> Error (--color-warn: #b23d1f)</div
                    >
                    <div class="container__row-item"
                        ><span class="color-box color-green"></span> Green (--color-green: #6d951d)</div
                    >
                    <div class="container__row-item"
                        ><span class="color-box color-blue"></span> Blue (--color-blue: #1260ac)</div
                    >
                    <div class="container__row-item"
                        ><span class="color-box color-grey-500"></span> Grey 500 (--color-grey: #7e7e7e)
                    </div>
                    <div class="container__row-item"
                        ><span class="color-box color-grey-200"></span> Grey 200 (--color-grey-light: #dbdbdb)</div
                    >
                    <div class="container__row-item"
                        ><span class="color-box color-grey-50"></span> Grey 50 (--color-grey-white: #f5f5f5)
                    </div>
                    <div class="container__row-item"
                        ><span class="color-box color-black"></span> Black (--color-black: #000000)</div
                    >
                    <div class="container__row-item"
                        ><span class="color-box color-white"></span> White (--color-white: #ffffff)</div
                    >
                </div>
            </div>
            <!-- Avatar Select -->
            <div class="container__component" id="avatar-select">
                <h2 class="container__title">Riege Avatar Select (click on the box)</h2>
                <div class="container__row">
                    <riege-avatar-selector #avatar [editable]="true"> </riege-avatar-selector>
                </div>
            </div>
            <!-- Badge -->
            <div class="container__component" id="badge">
                <h2 class="container__title">Riege Badge</h2>
                <div class="container__row">
                    <span class="riege-badge badge--primary">primary</span>
                    <span class="riege-badge badge--secondary">secondary</span>
                    <span class="riege-badge badge--grey">grey</span>
                </div>
            </div>
            <!-- Button -->
            <div class="container__component" id="button">
                <h2 class="container__title">Riege Button</h2>
                <div class="container__row">
                    <h3 class="styleguide--button-type">Stroked</h3>
                    <button class="riege-button" mat-stroked-button color="primary">Primary</button>
                    <button class="riege-button" mat-stroked-button color="accent">Accent</button>
                    <button class="riege-button" mat-stroked-button color="warn">Warn</button>
                    <button class="riege-button" mat-stroked-button disabled="disabled">Disabled</button>
                    <a href="#" target="_blank" mat-stroked-button>Link</a>
                </div>
                <div class="container__row">
                    <h3 class="styleguide--button-type">Flat</h3>
                    <button class="riege-button" mat-flat-button color="primary">Primary</button>
                    <button class="riege-button" mat-flat-button color="accent">Accent</button>
                    <button class="riege-button" mat-flat-button color="warn">Warn</button>
                    <button class="riege-button" mat-flat-button disabled="disabled">Disabled</button>
                    <a href="#" target="_blank" mat-flat-button>Link</a>
                </div>
                <div class="container__row">
                    <h3 class="styleguide--button-type">Icon</h3>
                    <button
                        mat-icon-button
                        class="riege-button riege-button--icon"
                        aria-label="Example icon button with a vertical three dot icon">
                        <mat-icon class="riege-icon">more_vert</mat-icon>
                    </button>
                    <button
                        mat-icon-button
                        class="riege-button riege-button--icon"
                        color="primary"
                        aria-label="Example icon button with a home icon">
                        <mat-icon class="riege-icon">home</mat-icon>
                    </button>
                    <button
                        mat-icon-button
                        class="riege-button riege-button--icon"
                        color="accent"
                        aria-label="Example icon button with a menu icon">
                        <mat-icon class="riege-icon">menu</mat-icon>
                    </button>
                    <button
                        mat-icon-button
                        class="riege-button riege-button--icon"
                        color="warn"
                        aria-label="Example icon button with a heart icon">
                        <mat-icon class="riege-icon">favorite</mat-icon>
                    </button>
                    <button
                        mat-icon-button
                        class="riege-button riege-button--icon"
                        disabled
                        aria-label="Example icon button with a open in new tab icon">
                        <mat-icon class="riege-icon">open_in_new</mat-icon>
                    </button>
                </div>
                <div class="container__row">
                    <h3 class="styleguide--button-type">Button with Icon</h3>
                    <button class="riege-button" mat-flat-button color="primary">
                        <mat-icon class="riege-icon" aria-hidden="true">check</mat-icon>
                        Button with icon left
                    </button>
                    <button class="riege-button" mat-flat-button color="accent">
                        <mat-icon class="riege-icon" iconPositionEnd aria-hidden="true">house</mat-icon>
                        Button with icon right
                    </button>
                    <button class="riege-button" mat-stroked-button color="primary">
                        <mat-icon class="riege-icon" aria-hidden="true">rocket</mat-icon>
                        Button with icon left and right
                        <mat-icon class="riege-icon" iconPositionEnd aria-hidden="true">language</mat-icon>
                    </button>
                </div>
            </div>
            <!-- Button Toggle -->
            <div class="container__component" id="button-toggle">
                <h2 class="container__title">Riege Button Toggle</h2>
                <div class="container__row">
                    <h3 class="flex-child--full-width">Button toggle with checkmark</h3>
                    <mat-button-toggle-group class="riege-button-toggle" name="doors" aria-label="doors">
                        <mat-button-toggle value="doorone">Door one</mat-button-toggle>
                        <mat-button-toggle value="doortwo">Door two</mat-button-toggle>
                        <mat-button-toggle value="doorthree">Door three</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <div class="container__row">
                    <h3 class="flex-child--full-width">Button toggle without checkmark</h3>
                    <mat-button-toggle-group
                        class="riege-button-toggle"
                        name="favoriteColor"
                        aria-label="favoriteColor"
                        hideSingleSelectionIndicator>
                        <mat-button-toggle value="red">Red</mat-button-toggle>
                        <mat-button-toggle value="green">Green</mat-button-toggle>
                        <mat-button-toggle value="yellow">Yellow</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <div class="container__row">
                    <h3 class="flex-child--full-width">Button toggle multiple choice</h3>
                    <mat-button-toggle-group
                        class="riege-button-toggle"
                        name="ingredients"
                        aria-label="ingredients"
                        multiple>
                        <mat-button-toggle value="doorone">Flour</mat-button-toggle>
                        <mat-button-toggle value="doortwo">Eggs</mat-button-toggle>
                        <mat-button-toggle value="doorthree">Sugar</mat-button-toggle>
                        <mat-button-toggle value="doorthree">Milk</mat-button-toggle>
                        <mat-button-toggle value="doorthree">Cinnamon</mat-button-toggle>
                        <mat-button-toggle value="doorthree">Vanilla</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <div class="container__row">
                    <h3 class="flex-child--full-width">Button toggle with icon</h3>
                    <mat-button-toggle-group
                        class="riege-button-toggle"
                        name="choice"
                        aria-label="choice"
                        hideSingleSelectionIndicator>
                        <mat-button-toggle value="one"
                            >One
                            <mat-icon
                                class="riege-icon md-16 margin-left--base-quarter"
                                iconPositionEnd
                                aria-hidden="true"
                                >view_list</mat-icon
                            ></mat-button-toggle
                        >
                        <mat-button-toggle value="two"
                            >Two
                            <mat-icon
                                class="riege-icon md-16 margin-left--base-quarter"
                                iconPositionEnd
                                aria-hidden="true"
                                >info</mat-icon
                            ></mat-button-toggle
                        >
                        <mat-button-toggle value="three"
                            >Three
                            <mat-icon
                                class="riege-icon md-16 margin-left--base-quarter"
                                iconPositionEnd
                                aria-hidden="true"
                                >house</mat-icon
                            ></mat-button-toggle
                        >
                    </mat-button-toggle-group>
                </div>
            </div>
            <!-- Card -->
            <div class="container__component" id="card">
                <h2 class="container__title">Riege Card</h2>
                <div class="container__row">
                    <mat-card class="riege-card" appearance="outlined">
                        <mat-card-content class="has-title-icon">
                            <div class="mat-card-content__icon">
                                <mat-icon
                                    class="riege-icon"
                                    aria-hidden="false"
                                    aria-label="Scope Tenants"
                                    fontIcon="domain"></mat-icon>
                            </div>
                            <mat-card-title>Header Title</mat-card-title>
                            <p>
                                The Shiba Inu is the smallest of the six original and distinct spitz breeds of dog from
                                Japan. A small, agile dog that copes very well with mountainous terrain, the Shiba Inu
                                was originally bred for hunting.
                            </p>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
            <!-- Card--Marketing -->
            <div class="container__component" id="card-marketing">
                <h2 class="container__title">Riege Card Marketing Style</h2>
                <div class="container__row">
                    <mat-card class="riege-card riege-card--marketing" appearance="outlined">
                        <mat-card-content class="has-title-icon">
                            <div class="mat-card-content__icon">
                                <mat-icon
                                    class="riege-icon"
                                    aria-hidden="false"
                                    aria-label="Scope Tenants"
                                    fontIcon="domain"></mat-icon>
                            </div>
                            <mat-card-title>Header Title</mat-card-title>
                            <p>
                                The Shiba Inu is the smallest of the six original and distinct spitz breeds of dog from
                                Japan. A small, agile dog that copes very well with mountainous terrain, the Shiba Inu
                                was originally bred for hunting.
                            </p>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
            <!-- Card--Marketing -->
            <div class="container__component" id="card-community">
                <h2 class="container__title">Riege Card Community</h2>
                <div class="container__row">
                    <mat-card class="riege-card riege-card--community" appearance="outlined">
                        <mat-card-content class="has-title-icon">
                            <div class="content-header">
                                <div class="mat-card-content__icon">
                                    <mat-icon
                                        class="riege-icon md-40"
                                        aria-hidden="false"
                                        aria-label="Scope Tenants"
                                        fontIcon="domain"></mat-icon>
                                </div>
                                <mat-card-title>Header Title</mat-card-title>
                            </div>
                            <div class="community-card__adress-wrapper">
                                <div class="community-card__adress-item">
                                    <mat-icon class="riege-icon md-16">place</mat-icon>
                                    <span
                                        >Frachtgebäude Modul G <br />
                                        85356 Munich Airport, Germany</span
                                    >
                                </div>
                                <div class="community-card__adress-item">
                                    <mat-icon class="riege-icon md-16">flight</mat-icon>
                                    <span>Airfeight</span>
                                </div>
                                <div class="community-card__adress-item">
                                    <mat-icon class="riege-icon md-16">directions_boat</mat-icon>
                                    <span>Seafeight</span>
                                </div>
                                <div class="community-card__adress-item">
                                    <mat-icon class="riege-icon md-16">directions_train</mat-icon>
                                    <span>Railfeight</span>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
            <!-- Card with image -->
            <div class="container__component" id="card-image">
                <h2 class="container__title">Riege Card with image</h2>
                <div class="container__row">
                    <mat-card class="riege-card" appearance="outlined">
                        <img
                            mat-card-image
                            src="https://material.angular.io/assets/img/examples/shiba2.jpg"
                            alt="Photo of a Shiba Inu" />
                        <mat-card-content>
                            <mat-card-title>Header Title</mat-card-title>
                            <mat-card-subtitle>Header Subtitle</mat-card-subtitle>
                            <p>
                                The Shiba Inu is the smallest of the six original and distinct spitz breeds of dog from
                                Japan. A small, agile dog that copes very well with mountainous terrain, the Shiba Inu
                                was originally bred for hunting.
                            </p>
                        </mat-card-content>
                        <mat-card-actions>
                            <button class="riege-button" mat-flat-button color="primary">ACTION Button</button>
                            <button class="riege-button" mat-stroked-button>ACTION Button</button>
                        </mat-card-actions>
                    </mat-card>
                </div>
            </div>
            <!-- Card with link -->
            <div class="container__component">
                <h2 class="container__title">Riege Card with a link (hover to see it)</h2>
                <div class="container__row">
                    <mat-card class="riege-card" appearance="outlined">
                        <a class="link--box-shadow" href="#">
                            <img
                                mat-card-image
                                src="https://material.angular.io/assets/img/examples/shiba2.jpg"
                                alt="Photo of a Shiba Inu" />
                            <mat-card-content>
                                <p class="mat-card__overline">Jul 31, 2024</p>
                                <mat-card-title>Header Title</mat-card-title>
                                <mat-card-subtitle>Header Subtitle</mat-card-subtitle>
                                <p class="mat-card__infotext">
                                    The Shiba Inu is the smallest of the six original and distinct spitz breeds of dog
                                    from Japan. A small, agile dog that copes very well with mountainous terrain, the
                                    Shiba Inu was originally bred for hunting.
                                </p>
                            </mat-card-content>
                            <mat-card-actions>
                                <button class="riege-button" mat-flat-button color="primary">ACTION Button</button>
                                <button class="riege-button" mat-stroked-button>ACTION Button</button>
                            </mat-card-actions>
                        </a>
                    </mat-card>
                </div>
            </div>
            <!-- Cards im a grid -->
            <div class="container__component">
                <h2 class="container__title">Riege Cards in a grid</h2>
                <!-- row 1 -->
                <div class="container__row">
                    <div class="row is-desktop">
                        <div class="column is-flex">
                            <mat-card class="riege-card" appearance="outlined">
                                <a class="link--box-shadow link--flex-streched" href="#">
                                    <img
                                        mat-card-image
                                        src="https://picsum.photos/id/69/1777/1000"
                                        alt="Photo of a Shiba Inu" />
                                    <mat-card-content>
                                        <p class="mat-card__overline">Jul 31, 2024</p>
                                        <mat-card-title
                                            >Scope: The flexible Software Solution for Freight
                                            Forwarders</mat-card-title
                                        >
                                        <mat-card-subtitle>Header Subtitle</mat-card-subtitle>
                                        <p class="mat-card__infotext">
                                            The Shiba Inu is the smallest of the six original and distinct spitz breeds
                                            of dog from Japan. A small, agile dog that copes very well with mountainous
                                            terrain, the Shiba Inu was originally bred for hunting.
                                        </p>
                                    </mat-card-content>
                                    <mat-card-actions>
                                        <button class="riege-button" mat-flat-button color="primary"
                                            >ACTION Button</button
                                        >
                                    </mat-card-actions>
                                </a>
                            </mat-card>
                        </div>
                        <div class="column is-flex">
                            <mat-card class="riege-card" appearance="outlined">
                                <a class="link--box-shadow link--flex-streched" href="#">
                                    <img
                                        mat-card-image
                                        src="https://picsum.photos/id/170/1777/1000"
                                        alt="Photo of a Shiba Inu" />
                                    <mat-card-content>
                                        <p class="mat-card__overline">Jul 18, 2024</p>
                                        <mat-card-title>The Verified Gross Mass (VGM) in Ocean Freight</mat-card-title>
                                        <mat-card-subtitle
                                            >This is a long Header Subtitle with a lot of subtitle
                                            information</mat-card-subtitle
                                        >
                                        <p class="mat-card__infotext">
                                            The Shiba Inu is the smallest of the six original and distinct spitz breeds
                                            of dog from Japan. A small, agile dog that copes very well with mountainous
                                            terrain, the Shiba Inu was originally bred for hunting.
                                        </p>
                                    </mat-card-content>
                                    <mat-card-actions>
                                        <button class="riege-button" mat-flat-button color="primary"
                                            >ACTION Button</button
                                        >
                                    </mat-card-actions>
                                </a>
                            </mat-card>
                        </div>
                        <div class="column is-flex">
                            <mat-card class="riege-card" appearance="outlined">
                                <a class="link--box-shadow link--flex-streched" href="#">
                                    <img
                                        mat-card-image
                                        src="https://picsum.photos/id/124/1777/1000"
                                        alt="Photo of a Shiba Inu" />
                                    <mat-card-content>
                                        <p class="mat-card__overline">Jul 6, 2024</p>
                                        <mat-card-title>What's new in Scope 24.6?</mat-card-title>
                                        <mat-card-subtitle>Header Subtitle</mat-card-subtitle>
                                        <p class="mat-card__infotext">
                                            The Shiba Inu is the smallest of the six original and distinct spitz breeds
                                            of dog from Japan.
                                        </p>
                                    </mat-card-content>
                                    <mat-card-actions>
                                        <button class="riege-button" mat-flat-button color="primary"
                                            >ACTION Button</button
                                        >
                                    </mat-card-actions>
                                </a>
                            </mat-card>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Chips -->
            <div class="container__component" id="chips">
                <h2 class="container__title">Riege Chips</h2>
                <div class="container__row">
                    <mat-chip-listbox aria-label="Fish selection">
                        <mat-chip-option class="riege-chips" tabIndex="0">Standard</mat-chip-option>
                        <mat-chip-option class="riege-chips" tabIndex="0" selected>Selected</mat-chip-option>
                        <mat-chip-option class="riege-chips" tabIndex="0" disabled="disabled">Disabled</mat-chip-option>
                    </mat-chip-listbox>
                </div>
            </div>
            <!-- Dialog -->
            <div class="container__component" id="dialog">
                <h2 class="container__title">Riege Dialog</h2>
                <div class="container__row">
                    <button class="riege-button" mat-stroked-button (click)="openDialog()">Launch dialog</button>
                </div>
            </div>
            <!-- Dialog Template -->
            <ng-template #dialogTemplate>
                <mat-dialog-content>
                    <div class="img-wrapper">
                        <img src="assets/images/launching-runtime.png" aria-hidden="true" alt="Launch Runtime Logo" />
                    </div>

                    <h2 mat-dialog-title>Dialog Title</h2>

                    <p
                        >Lorem ipsum dolor sit amet consectetur adipisicing elit. Ad quisquam at rem eligendi sequi
                        culpa exercitationem reprehenderit quia alias maiores impedit, temporibus officia suscipit
                        repellendus qui accusantium expedita, amet quaerat.</p
                    >

                    <mat-nav-list>
                        <ng-container *ngFor="let runtime of RUNTIMES">
                            <a mat-list-item href="#" target="_blank">
                                <span mat-line>
                                    <mat-icon
                                        class="riege-icon {{ runtime.icon }}"
                                        svgIcon="{{ runtime.icon }}"
                                        aria-hidden="true"></mat-icon>
                                    {{ runtime.os }}
                                </span>
                                <span mat-line class="description">{{ runtime.description }}</span>
                            </a>
                        </ng-container>
                    </mat-nav-list>

                    <div class="form-field__wrapper">
                        <mat-form-field appearance="outline" color="accent">
                            <mat-label>Input</mat-label>
                            <input matInput />
                        </mat-form-field>
                        <mat-form-field appearance="outline" color="accent">
                            <mat-label>Select</mat-label>
                            <mat-select>
                                <mat-option value="one">First option</mat-option>
                                <mat-option value="two">Second option</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </mat-dialog-content>

                <mat-dialog-actions align="end">
                    <button class="riege-button" mat-stroked-button>Action click</button>
                    <button class="riege-button" mat-flat-button mat-dialog-close color="primary">Action close</button>
                </mat-dialog-actions>
            </ng-template>
            <!-- Dropzone -->
            <div class="container__component" id="dropzone">
                <h2 class="container__title">Riege Dropzone (with local upload file after you drop a file)</h2>
                <div class="container__row">
                    <span *ngIf="hasFile | async, then image else dropzone"></span>
                    <ng-template #image>
                        <div class="signature">
                            <img
                                class="signature__image"
                                src="assets/images/launch-scope.png"
                                aria-hidden="true"
                                alt="" />
                            <button
                                class="riege-button signature__btn-delete"
                                mat-stroked-button
                                color="warn"
                                (click)="deleteSignature()"
                                >Remove file</button
                            >
                        </div>
                    </ng-template>

                    <ng-template #dropzone>
                        <riege-file-dropzone
                            [directUpload]="true"
                            [multiple]="false"
                            [allowedTypes]="['jpg','jpeg','png']"
                            [allowedSize]="2048000"
                            (fileChanged)="UploadDropzoneFile($event)"
                            [progress]="0">
                        </riege-file-dropzone>
                    </ng-template>
                </div>
            </div>
            <!-- Form Fields -->
            <div class="container__component" id="form-fields">
                <h2 class="container__title">Riege Form Fields</h2>
                <div class="container__row">
                    <div class="form-field__wrapper">
                        <div class="row">
                            <div class="column">
                                <mat-form-field appearance="outline" class="half-width" color="accent">
                                    <mat-label>Input (half-width)</mat-label>
                                    <input
                                        matInput
                                        placeholder="Input Text"
                                        [formControl]="inputFormControl"
                                        type="text"
                                        required />
                                    <mat-hint>This is an optional hint text. </mat-hint>
                                    @if (inputFormControl.hasError('required')) {
                                    <mat-error>This is an example required error.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="column">
                                <mat-form-field appearance="outline" class="half-width" color="accent">
                                    <mat-label>Select (half-width)</mat-label>
                                    <mat-select placeholder="Select an option">
                                        <mat-option value="one">First option</mat-option>
                                        <mat-option value="two">Second option</mat-option>
                                        <mat-option value="two">Third option</mat-option>
                                        <mat-option value="two">Fourth option</mat-option>
                                        <mat-option value="two">Fifth option</mat-option>
                                    </mat-select>
                                    <mat-hint>This is an optional hint text.</mat-hint>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="column">
                                <mat-form-field class="half-width" color="accent">
                                    <span matPrefix><mat-icon class="riege-icon">search (half-width)</mat-icon></span>
                                    <input matInput placeholder="Search" type="text" [formControl]="search" />
                                    <button
                                        *ngIf="search.value"
                                        mat-icon-button
                                        class="riege-button riege-button--icon"
                                        matSuffix
                                        #input
                                        aria-label="Reset search"
                                        (click)="search.reset(); input.focus();">
                                        <mat-icon class="riege-icon">close</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="column is-full-tablet">
                                <mat-form-field appearance="outline" color="accent" class="full-width">
                                    <mat-label>Input 100% width</mat-label>
                                    <input
                                        matInput
                                        placeholder="Input Text"
                                        [formControl]="inputFormControl"
                                        type="text"
                                        required />
                                    <mat-hint>This is an optional hint text. </mat-hint>
                                    @if (inputFormControl.hasError('required')) {
                                    <mat-error>This is an example required error.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="column is-half-desktop">
                                <!-- multiple lines test same height flexbox -->
                                <mat-form-field appearance="outline" color="accent" class="full-width">
                                    <mat-label>Input 50% width</mat-label>
                                    <input
                                        matInput
                                        placeholder="Input Text"
                                        [formControl]="inputFormControl"
                                        type="text"
                                        required />
                                    <mat-hint>This is an optional hint text. </mat-hint>
                                    @if (inputFormControl.hasError('required')) {
                                    <mat-error>This is an example required error.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div class="column is-half-desktop">
                                <mat-form-field appearance="outline" color="accent" class="full-width">
                                    <mat-label>Input 50% width</mat-label>
                                    <input
                                        matInput
                                        placeholder="Input Text"
                                        [formControl]="inputFormControl"
                                        type="text"
                                        required />
                                    <mat-hint>This is an optional hint text. </mat-hint>
                                    @if (inputFormControl.hasError('required')) {
                                    <mat-error>This is an example required error.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="column is-half-desktop">
                                <!-- second row -->

                                <mat-form-field appearance="outline" color="accent" class="full-width">
                                    <mat-label>Input 50% width</mat-label>
                                    <input
                                        matInput
                                        placeholder="Input Text"
                                        [formControl]="inputFormControl"
                                        type="text"
                                        required />
                                    @if (inputFormControl.hasError('required')) {
                                    <mat-error>This is an example required error.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                            <div class="column is-half-desktop">
                                <mat-form-field appearance="outline" color="accent" class="full-width">
                                    <mat-label>Input 50% width</mat-label>
                                    <input
                                        matInput
                                        placeholder="Input Text"
                                        [formControl]="inputFormControl"
                                        type="text"
                                        required />
                                    <mat-hint>This is an optional hint text. </mat-hint>
                                    @if (inputFormControl.hasError('required')) {
                                    <mat-error>This is an example required error.</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="column is-half-desktop">
                                <mat-form-field appearance="outline" color="accent" class="full-width">
                                    <mat-label>Passar Access Token</mat-label>
                                    <textarea matInput placeholder="textarea" rows="3"></textarea>

                                    <mat-hint ngClass="passar-token__helper-text" i18n="@@input-hint-passar-token"
                                        >The Passar Access Token starts with ‘ey’.</mat-hint
                                    >
                                </mat-form-field>
                            </div>
                            <div class="column is-half-desktop">
                                <mat-form-field appearance="outline" color="accent" class="full-width">
                                    <mat-label>Passar Access Token</mat-label>
                                    <textarea matInput placeholder="textarea" rows="3"></textarea>

                                    <mat-hint ngClass="passar-token__helper-text" i18n="@@input-hint-passar-token"
                                        >The Passar Access Token starts with ‘ey’.</mat-hint
                                    >
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Icon -->
            <div class="container__component" id="icons">
                <h2 class="container__title">Riege Icon</h2>
                <div class="container__row">
                    <div class="container__wrap">
                        <h3>16px</h3>
                        <mat-icon class="riege-icon md-16" aria-hidden="false" aria-label="Example home icon"
                            >lightbulb</mat-icon
                        >
                    </div>
                    <div class="container__wrap">
                        <h3>20px (grey)</h3>
                        <mat-icon
                            class="riege-icon md-20"
                            style="color: #7e7e7e"
                            aria-hidden="false"
                            aria-label="Example home icon"
                            >lightbulb</mat-icon
                        >
                    </div>
                    <div class="container__wrap">
                        <h3>Regular (24px default size)</h3>
                        <mat-icon class="riege-icon" aria-hidden="false" aria-label="Example home icon"
                            >lightbulb</mat-icon
                        >
                    </div>
                    <div class="container__wrap">
                        <h3>32px (warn)</h3>
                        <mat-icon
                            class="riege-icon md-32"
                            color="warn"
                            aria-hidden="false"
                            aria-label="Example home icon"
                            >lightbulb</mat-icon
                        >
                    </div>
                </div>
            </div>
            <!-- Menu -->
            <div class="container__component" id="menu">
                <h2 class="container__title">Riege Menu</h2>
                <div class="container__row">
                    <button mat-button [matMenuTriggerFor]="menu">Menu</button>
                    <mat-menu #menu="matMenu" class="riege-menu">
                        <button mat-menu-item>Item 1</button>
                        <button mat-menu-item>Item 2</button>
                        <button mat-menu-item>Item 3</button>
                        <button mat-menu-item>Item 4</button>
                    </mat-menu>
                    <!-- with icon in list -->
                    <button mat-button [matMenuTriggerFor]="menuIcon" aria-label="Menu List with Icons"
                        >Menu with list icon</button
                    >
                    <mat-menu #menuIcon="matMenu" class="riege-menu">
                        <button mat-menu-item>
                            <mat-icon class="riege-icon">dialpad</mat-icon>
                            <span>Redial</span>
                        </button>
                        <button mat-menu-item disabled>
                            <mat-icon class="riege-icon">voicemail</mat-icon>
                            <span>Check voice mail</span>
                        </button>
                        <button mat-menu-item>
                            <mat-icon class="riege-icon">notifications_off</mat-icon>
                            <span>Disable alerts</span>
                        </button>
                    </mat-menu>
                    <!-- with icon button -->
                    <button
                        mat-icon-button
                        class="riege-button"
                        [matMenuTriggerFor]="menuIconButton"
                        aria-label="Example icon-button with a menu">
                        <mat-icon class="riege-icon">more_vert</mat-icon>
                    </button>
                    <mat-menu #menuIconButton="matMenu" class="riege-menu">
                        <button mat-menu-item>
                            <mat-icon class="riege-icon">dialpad</mat-icon>
                            <span>Redial</span>
                        </button>
                        <button mat-menu-item>
                            <mat-icon class="riege-icon">voicemail</mat-icon>
                            <span>Check voice mail</span>
                        </button>
                        <button mat-menu-item>
                            <mat-icon class="riege-icon">notifications_off</mat-icon>
                            <span>Disable alerts</span>
                        </button>
                    </mat-menu>
                    <!-- with divider-->
                    <button mat-button [matMenuTriggerFor]="menuDivider">Menu with divider</button>
                    <mat-menu #menuDivider="matMenu" class="riege-menu">
                        <button mat-menu-item>Item 1</button>
                        <button mat-menu-item>Item 2</button>
                        <mat-divider class="reset-margin--all"></mat-divider>
                        <button mat-menu-item>Item 3</button>
                        <button mat-menu-item>Item 4</button>
                        <mat-divider class="reset-margin--all"></mat-divider>
                        <button mat-menu-item>Item 5</button>
                        <button mat-menu-item>Item 6</button>
                    </mat-menu>
                </div>
            </div>
            <!-- Paginator -->
            <div class="container__component" id="paginator">
                <h2 class="container__title">Riege Paginator</h2>
                <div class="container__row">
                    <mat-paginator
                        class="riege-paginator"
                        [length]="100"
                        [pageSize]="10"
                        [pageSizeOptions]="[10,25,50,99]"
                        aria-label="Select page"
                        showFirstLastButtons="true">
                    </mat-paginator>
                </div>
            </div>
            <!-- Progress Bar -->
            <div class="container__component" id="progress-bar">
                <h2 class="container__title">Riege Progressbar</h2>
                <div class="container__row">
                    <mat-progress-bar
                        class="riege-progressbar"
                        mode="indeterminate"
                        aria-label="Loading..."></mat-progress-bar>
                </div>
            </div>
            <!-- Slider -->
            <div class="container" id="slider">
                <div class="container__inner">
                    <h2 class="container__title">Riege Slider</h2>
                    <div class="column">
                        <app-keen-slider [communityData]="communityData"></app-keen-slider>
                    </div>
                </div>
            </div>
            <!-- Slide Toggle -->
            <div class="container__component" id="slide-toggle">
                <h2 class="container__title">Riege Slide Toggle</h2>
                <div class="container__row">
                    <div class="container__row-item">
                        <mat-slide-toggle color="primary">Default</mat-slide-toggle>
                    </div>
                    <div class="container__row-item">
                        <mat-slide-toggle color="primary" checked>Pre-Checked</mat-slide-toggle>
                    </div>
                    <div class="container__row-item">
                        <mat-slide-toggle disabled>Disabled</mat-slide-toggle>
                    </div>
                </div>
            </div>
            <!-- Snackbar -->
            <div class="container__component" id="snackbar">
                <h2 class="container__title">Riege Snackbar</h2>
                <div class="container__row">
                    <div class="container__row-item">
                        <mat-form-field appearance="outline">
                            <mat-label>Message</mat-label>
                            <input
                                matInput
                                value="Ein Fehler ist aufgetreten - bitte kontaktieren Sie den support."
                                #message />
                        </mat-form-field>
                    </div>
                    <div class="container__row-item">
                        <mat-form-field appearance="outline">
                            <mat-label>Action</mat-label>
                            <input matInput value="OK" #action />
                        </mat-form-field>
                    </div>
                    <div class="container__row-item">
                        <button
                            class="riege-button"
                            mat-flat-button
                            color="primary"
                            (click)="openSnackBar(message.value, action.value)"
                            >Snackbar anzeigen</button
                        >
                    </div>
                </div>
            </div>
            <!-- Table -->
            <div class="container__component" id="table">
                <h2 class="container__title">Riege Table</h2>
                <div class="container__row">
                    <div class="riege-table--sticky-wrapper">
                        <table
                            mat-table
                            [dataSource]="tableDataSource"
                            matSort
                            (matSortChange)="announceSortChange($event)"
                            class="riege-table">
                            <colgroup>
                                <col class="wp-15" />
                                <col class="wp-25" />
                                <col class="wp-15" />
                                <col class="wp-15" />
                                <col class="wp-15" />
                                <col class="wp-15" />
                            </colgroup>

                            <!-- Avatar Column -->
                            <ng-container matColumnDef="avatar">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    mat-sort-header
                                    sortActionDescription="Sort by number">
                                    Icon
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-icon
                                        class="riege-icon"
                                        class="{{ element.avatar }}"
                                        svgIcon="{{ element.avatar || 'avatar_placeholder' }}"
                                        aria-hidden="true">
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <!-- Name and E-Mail Column -->
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Text and Subtext</th>
                                <td mat-cell *matCellDef="let element" class="riege-table--column-bold">
                                    <span>{{ element.name }}</span> <br />
                                    <span class="table__email">{{ element.email }}</span>
                                </td>
                            </ng-container>
                            <!-- Text Column -->
                            <ng-container matColumnDef="text">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort">
                                    Regular text
                                </th>
                                <td mat-cell *matCellDef="let element"> {{element.text}} </td>
                            </ng-container>
                            <!-- Link Column -->
                            <ng-container matColumnDef="link">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort">
                                    Link
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <a
                                        class="table__link"
                                        matTooltip="Tooltip optional"
                                        matTooltipPosition="above"
                                        aria-label="Tooltip"
                                        href="#"
                                        >{{ element.link }}</a
                                    >
                                </td>
                            </ng-container>
                            <!-- Status Column -->
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort">
                                    Status
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div class="riege-table__status-wrapper">
                                        <mat-icon
                                            class="riege-icon md-16"
                                            [ngClass]="{'green': element.status === true, 'red': element.status === false}"
                                            >circle</mat-icon
                                        >
                                        <span class="riege-table--status-authorized">{{ element.status }}</span>
                                    </div>
                                </td>
                            </ng-container>
                            <!-- Symbol Column -->
                            <ng-container matColumnDef="button">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort">
                                    Button
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-stroked-button class="riege-button"> Button </button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </div>
                </div>
            </div>
            <!-- Tabs -->
            <div class="container__component" id="tabs">
                <h2 class="container__title">Riege Tabs</h2>
                <div class="container__row">
                    <mat-tab-group class="riege-tabs" mat-stretch-tabs="false" mat-align-tabs="start" color="accent">
                        <mat-tab label="Tab 1"> Tab 1 Content </mat-tab>
                        <mat-tab label="Tab 2"> Tab 2 Content </mat-tab>
                        <mat-tab label="Tab 3"> Tab 3 Content</mat-tab>
                        <mat-tab label="Tab 4"> Tab 4 Content</mat-tab>
                    </mat-tab-group>
                </div>
            </div>
            <!-- Textlink -->
            <div class="container__component" id="textlink">
                <h2 class="container__title">Riege Textlink</h2>
                <div class="container__row">
                    <h3 class="flex-child--full-width">Textlink standard</h3>
                    <a class="riege-textlink" href="#"> Open update history </a>
                </div>
                <div class="container__row">
                    <!-- with icon -->
                    <h3 class="flex-child--full-width">Texlink with icon</h3>
                    <a class="riege-textlink" href="#" target="_blank">
                        <span class="riege-textlink--icon-text">Open update history</span>
                        <mat-icon class="riege-icon md-16">open_in_new</mat-icon>
                    </a>
                </div>
            </div>
            <!-- Tooltip -->
            <div class="container__component" id="tooltip">
                <h2 class="container__title">Riege Tooltip</h2>
                <div class="container__row">
                    <button
                        mat-stroked-button
                        class="riege-button"
                        matTooltip="Position below"
                        aria-label="Button that displays a tooltip when focused or hovered over">
                        Tooltip - standard position
                    </button>
                    <button
                        mat-flat-button
                        class="riege-button"
                        matTooltipPosition="above"
                        color="primary"
                        matTooltip="Position above"
                        aria-label="Button that displays a tooltip when focused or hovered over">
                        Tooltip - position above
                    </button>
                    <button
                        mat-icon-button
                        class="riege-button riege-button--icon"
                        color="warn"
                        matTooltip="Tooltip - Icon Button"
                        matTooltipPosition="right">
                        <mat-icon class="riege-icon">delete</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
</main>
